import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessState } from '@state/business';
import { UserProfileState } from '@state/user-profile';
import { UserProfileDispatch } from '@state/user-profile/dispatch';
import { combineLatest, Observable } from 'rxjs';
import { TeranetModalState } from 'src/app/private/sale/teranet/teranet-guard-modal/modal.component';

@UntilDestroy()
@Component({
	selector: 'app-teranet-credentials',
	templateUrl: './teranet-credentials.component.html',
	styleUrls: ['./teranet-credentials.component.scss'],
	standalone: false,
})
export class ViewTeranetAccountComponent implements OnInit {
	public states = TeranetModalState;
	public state = TeranetModalState.LOGIN;

	@Select(UserProfileState.getTeranetPasswordExpired)
	passwordExpired$: Observable<boolean>;
	@SelectSnapshot(BusinessState.getTeranetAccountName)
	accountName: string;

	ngOnInit(): void {
		this.profileDispatch.SetTeranetPasswordExpired(false);
		combineLatest([this.passwordExpired$])
			.pipe(untilDestroyed(this))
			.subscribe(([passwordExpired]) => {
				if (passwordExpired) {
					this.state = TeranetModalState.CHANGE_PASSWORD;
				}
			});
	}

	constructor(private profileDispatch: UserProfileDispatch) {}
}
